module.exports = __webpack_public_path__ + "79ae6fe34f1782578e624459cb806b89.svg";